import { Box } from '@mui/material';
import ListCreateTab from 'components/ListCreateTab';
import React from 'react'
import { AiOutlineGift } from 'react-icons/ai';
import GlobalOfferCreate from './GlobalOfferCreate';
import GlobalOfferList from './GlobalOfferList';
import { DataSaverOnOutlined } from '@mui/icons-material';

const ManageGlobalOffers = () => {
    return (
        <Box sx={{ display: "flex", flex: 1 }}>
          <ListCreateTab
            mod="Event offers"
            viewIcon={<AiOutlineGift />}
            createIcon={<DataSaverOnOutlined />}
            createChildren={<GlobalOfferCreate />}
            listChildren={<GlobalOfferList />}
          />
        </Box>
      );
}

export default ManageGlobalOffers